<template>
    <component 
        v-model:show="modal"
        :is="page ? 'div' : 'modal'"
        body-classes="p-0"
        modal-classes="modal-dialog-centered modal-sm"
    >
        <card type="secondary" shadow
            header-classes="bg-secondary"
            body-classes="px-lg-4 py-lg-5"
            class="border-0"
            style="margin-bottom: 0"
            :class="page && 'page-card'"
        >
            <template #header>
                <div class="text-muted d-flex justify-content-between align-items-center">
                    <span>{{ $t('login.password.forgot') }}</span>
                    <button 
                        @click="modal=false; $emit('close')"
                        type="button" 
                        class="btn btn-link px-0 py-0 btn-sm"
                    >
                        <i class="mdi mdi-24px mdi-close"></i>
                    </button>
                </div>
            </template>
            <template v-if="true">
                <form role="form">
                    <base-input
                        v-model="email"
                        v-validate="'required|email'"
                        :name="$t('login.email')"
                        class="mb-3"
                        placeholder="Email"
                        prepend-icon="ni ni-email-83"
                        :error="errors.first($t('login.email'))"
                    ></base-input>
                    <div class="d-flex justify-content-center mt-4">
                        <Captcha ref="captcha"></Captcha>
                    </div>
                    <div class="text-center">
                        <base-button
                            @click.stop="submit"
                            :loading="loading"
                            type="success"
                            class="my-4"
                        >
                            {{ $t('login.password.reset') }}
                        </base-button>
                    </div>
                </form>
            </template>
        </card>
    </component>
</template>

<script>
import Card from '../../argon/components/Cards/Card';
import Modal from '../../argon/components/Modal';
import BaseInput from '../../argon/components/Inputs/BaseInput';
import BaseButton from '../../argon/components/BaseButton';
import Captcha from '../Common/Captcha';

export default {
    name: 'ForgotPassword',
    components: {
        Card,
        Modal,
        BaseInput,
        BaseButton,
        Captcha
    },
    emits: ['update:modelValue', 'close'],
    props: {
        modelValue: { 
            type: Boolean,
            required: true
        },
        page: Boolean
    },
    data() {
        return {
            email: '',
            loading: false,
            captcha: false,
        }
    },
    computed: {
        modal: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            }
        }
    },
    methods: {
        submit() {
            this.$validator.validate().then(async valid => {
                this.captcha = await this.$refs.captcha.send();
                if (valid && this.captcha) {

                    this.loading = true;

                    window.axios.get('/password/recovery', {
                        params: {
                            email: this.email
                        }
                    })
                    .then(res => {
                        this.$notify({ type: 'success', message: res.data.message })

                        // Redirect to home after password recovery process
                        setTimeout(() => {
                            location.href = '/login';
                        }, 1500)
                    })
                    .catch(err => {
                        this.$notify({ type: 'danger', message: this.$t('login.recovery.error') })
                        this.loading = false
                    })
                }
            })
        },
    }
}
</script>

<style>
.page-card{
    width: 320px;
    min-height: 500px;
}
</style>
